import script from "./mouthWash.vue?vue&type=script&setup=true&lang=js"
export * from "./mouthWash.vue?vue&type=script&setup=true&lang=js"

import "./mouthWash.vue?vue&type=style&index=0&id=3729d144&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3729d144"]])

export default __exports__